export default {
    //配件申请单
    partapplyname: '配件申请单号',
    servicename: '服务单号',
    applytype: '申请类型',
    approvalstatus: '审批状态',

    //系统公告
    startDate:'开始日期',
    endDate:'结束日期',
    noticeType:'公告类型',
    noticeTitle:'公告标题',
    noticeState:'阅读状态'
};


// WEBPACK FOOTER //
// ./src/module/locale/lang/zh-CN.js